import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import cartProductsAdapter from './cart_products.adapter';

import actions from './cart_products.actions';

import type { LoadingStatus } from 'types/common_types';
import type { CartProductsSliceInitialState } from './cart_products.types';

const initialState: CartProductsSliceInitialState = {
  status: 'idle',
  productsPerPage: 20,
  page: 1,
};

const cartProducts = createSlice({
  name: 'cartProducts',
  initialState: cartProductsAdapter.getInitialState(initialState),
  reducers: {
    reset() {
      return cartProductsAdapter.getInitialState(initialState);
    },
    addMany: cartProductsAdapter.addMany,
    setPage(state, { payload }: PayloadAction<number>) {
      return { ...state, page: payload };
    },
    updateCartProductsLoading(state, { payload }: PayloadAction<LoadingStatus>) {
      return { ...state, status: payload };
    },
    cartProductThumbnailError(state, { payload }: PayloadAction<number>) {
      // return cartProductsAdapter.updateOne(state, {
      //   id: payload,
      //   changes: {
      //     thumb_url: 'error',
      //   },
      // });
    },
  },
  extraReducers(builder) {
    builder
      .addCase(actions.getAll.fulfilled, (state, { payload }) => {
        return cartProductsAdapter.setAll(state, payload);
      })
      .addCase(actions.update.fulfilled, (state, { payload }) => {
        const update = cartProductsAdapter.upsertOne(state, payload);
        update.status = 'idle';
      })
      .addCase(actions.updateQuantity.pending, (state) => {
        return { ...state, status: 'loading' };
      })
      .addCase(actions.updateQuantity.fulfilled, (state, { payload }) => {
        const update = cartProductsAdapter.updateOne(state, {
          id: payload.id,
          changes: { ...payload },
        });
        update.status = 'idle';
      })

      .addCase(actions.destroy.pending, (state, { payload }) => {
        return { ...state, dropping: payload, status: 'loading' };
      })
      .addCase(actions.destroy.fulfilled, (state, { payload }) => {
        const update = cartProductsAdapter.removeOne(state, payload);

        const startIndex = update.productsPerPage * (update.page - 1);
        const currentPageIds = update.ids.slice(startIndex, startIndex + update.productsPerPage);

        if (currentPageIds.length === 0 && update.page !== 1) {
          update.page -= 1;
        }

        update.status = 'idle';
        return update;
      });
  },
});

export default cartProducts;
